const hoursEntryTypes = {
  WORK: 'work',
  HOLIDAY: 'holiday',
  VACATION: 'vacation',
  SICK: 'sick',
  COMPENSATION: 'compensation',
  TIME_OFF_IN_LIEU: 'time-off-in-lieu',
};

export default hoursEntryTypes;
